import { useQuery } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { UsersService } from '../services';

/**
 * React Query hook to fetch users by their IDs
 *
 * @param {string[]} userIds - Array of user IDs to fetch
 * @param {Object} [options] - Hook options
 * @param {boolean} [options.enabled=true] - Whether query should execute
 * @param {boolean} [options.refetchOnWindowFocus=false] - Refetch on window focus
 */
export const useGetUsersByIds = (userIds, options) => {
  const dispatch = useDispatch();
  const enabled = options?.enabled ?? (Array.isArray(userIds) && userIds.length > 0);

  const { data, error, isFetching, isLoading, isError } = useQuery({
    queryKey: ['GET_USERS_BY_IDS', userIds],
    queryFn: async () => {
      dispatch({ type: 'GET_USERS_BY_IDS_REQUEST' });

      return UsersService.getUsersByIds(userIds).finally(() =>
        dispatch({ type: 'GET_USERS_BY_IDS_SUCCESS' }),
      );
    },
    enabled,
    retry: false,
    refetchOnWindowFocus: options?.refetchOnWindowFocus ?? false,
  });

  return {
    data: data?.data || [],
    error,
    isError,
    isInitialLoading: isLoading,
    isLoading: isLoading || isFetching,
  };
};
